export enum EntityType {
  DRIVER = 'driver',
  VEHICLE = 'vehicle',
  FLEET_USER = 'fleet_user',
  ASSET = 'asset',
  GEOFENCE = 'geofence',
}

export enum EntityState {
  OFF = 'off',
  MOVING = 'moving',
  DRIVING = 'driving',
  IDLING = 'idling',
  STOP = 'stop',
  INVALID = 'invalid',
}

export enum AssetState {
  MOTION = 'motion',
  STATIONARY = 'stationary',
}

export enum EntityStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

export enum EngineCondition {
  RUNNING = 'running',
  IDLE = 'idle',
}
